import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW10LRG.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>Spetember 30, 2024</ClientTag>
                            <Title>Sleep</Title>
                            <TechniqueTitle>
                            Is your Sleep Optimal?
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>How much sleep does your body need? Typically most adults require anywhere from 6-9 hours of sleep each night. The exact amount depends on how much energy you burn throughout the day.</p>
                    <p className='content'>But why is sleep so essential for your overall health? Sleep impacts almost every area of your life - from physical health and mental clarity to productivity and emotional well-being. It is when your body rebuilds muscle, processes long-term memories, boost metabolism, and helps lower stress levels, leaving your more alert and refreshed. During sleep hormones are balanced, skin and muscle repair happens, and your brain solidifies what you have learned throughout your day. This is why sleep is essential for the body and mind!</p>
                     <p className='content'>In today’s fast-paced world, sleep issues have become all too common. Consistently getting below-optimal sleep can weaken your immune system, slow your reaction time, increase injury risk, raise the likelihood of dementia, and contribute to weight gain. That’s why prioritizing your sleep is essential for long-term health & wellbeing! </p>

                  
                    <h3 className='my-5'>How to Maximize Sleep Benefits</h3>
                    <div>
                      <p className='content'>1. Consistent Sleeping and Waking: Creating a consistent sleep will help to create a good sleep cycle allowing for proper melatonin and cortisol regulation. </p>
                      <p className='content'>2. No eating 3 hours before bed: Allow your digestive system to relax to allow for full body relaxation. </p>
                      <p className='content'>3. No exercising 1 hour before bed: Allow the physical body to wind down to prepare for full body relaxation </p>
                      <p className='content'>4. Herbal Remedies: Valerian, passionflower, and lemon balm </p>
                      <p className='content'>5. Supplements: Magnesium, melatonin, GABA, and L-theanine </p>
                      <p className='content'>6. Expert help: Speak with your naturopathic doctor to learn more about how to optimize your sleep! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW10" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);